import { FiltersResponse, NPSFilter } from '@/models/Filter';
import {FpAxios} from '@/services/FpAxios';
import { NPSFeedbackPublish, NPSOpinion, NPSSurvey } from '../models/NPS';
import processProxy from '@/env/processProxy';

class NPSApi {
  private npsAxios = FpAxios.create({ baseURL: processProxy.VUE_APP_BASE_OPINIONS_URL, });

  public async getOpinions(params: Partial<NPSFilter>): Promise<FiltersResponse<NPSOpinion>> {
    const response = await this.npsAxios.post('/feedback', params);
    return response.data;
  }

  public async pocessOpinion(opinionId: number, params: NPSFeedbackPublish): Promise<boolean> {
    const response = await this.npsAxios.post(`/feedback/${opinionId}/process`, params);
    return response.data;
  }

  public async replaceOpinion(uuid: string): Promise<NPSSurvey> {
    const response = await this.npsAxios.post(`/survey/${uuid}/replacement`);
    return response.data;
  }
}

export default new NPSApi();
